/**
 * Provident Fund maturity calculation (shared by web, mobile, calculator-service).
 */

export function calculatePf(monthlyContribution, employerContribution, interestRate, years) {
  let totalAmount = 0;
  let totalContribution = 0;

  for (let year = 0; year < years; year += 1) {
    for (let month = 0; month < 12; month += 1) {
      totalAmount += monthlyContribution + employerContribution;
      totalContribution += monthlyContribution + employerContribution;
    }
    const annualInterest = totalAmount * (interestRate / 100);
    totalAmount += annualInterest;
  }

  const totalInterest = totalAmount - totalContribution;

  return {
    totalContribution: Math.round(totalContribution),
    totalInterest: Math.round(totalInterest),
    maturityAmount: Math.round(totalAmount),
  };
}
